<template>
  <div class="w-full full-login font-poppins">
    <div class="w-full" v-if="token">
      <NavbarReset />
      <div class="m-auto w-full">
        <div class="block sm:flex justify-center align-items-center w-full">
          <form
            @submit.prevent="createPassword"
            class="h-screen xl:h-auto flex w-full"
            style="max-height: 600px"
          >
            <div class="grid grid-cols-2 gap-4 w-full">
              <div class="sm:col-span-2 md:col-span-1 col-span-2">
                <div class="my-4 mx-4 px-4 py-8">
                  <div class="intro-x mt-8 px-8">
                    <h1
                      class="font-crimson_pro text-theme-9 text-3xl font-semibold"
                    >
                      Crear nueva contraseña
                    </h1>
                  </div>
                  <div
                    class="my-10 mb-4 mx-4 px-4 rounded-md sm:w-11/12 w-full"
                  >
                    <div class="intro-x mt-8 px-8">
                      <span class="text-xs">Nueva contraseña</span>
                      <div class="input-group mt-1">
                        <input
                          :type="inputPasswordShow ? 'text' : 'password'"
                          class="form-control p-3 text-base"
                          placeholder="Nueva contraseña"
                          style="border-right-width: 0"
                          ref="password"
                          v-model="password"
                          @cut.prevent
                          @copy.prevent
                          @paste.prevent
                          required
                        />
                        <div
                          class="input-group-text flex cursor-pointer"
                          style="border-left-width: 0; background: white"
                          @click="
                            changeInputShowPassword({
                              ref: 'password',
                              input: 'inputPasswordShow'
                            })
                          "
                        >
                          <EyeIcon
                            class="w-4 h-4 my-auto"
                            v-if="!inputPasswordShow"
                          />
                          <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                        </div>
                      </div>
                    </div>
                    <div class="intro-x mt-3 px-10 text-xs flex flex-col">
                      <span>
                        Debe incluir
                        <span
                          :class="{ 'text-theme-6': !passwordHasMinLenght }"
                        >
                          mínimo 8 caracteres
                        </span>
                        y cumplir 3 de estas 4 características:
                      </span>
                      <span
                        class="mt-1 flex"
                        :class="{ 'opacity-40': !passwordHasUpperCase }"
                      >
                        <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos
                        una mayúscula
                      </span>
                      <span
                        class="mt-1 flex"
                        :class="{ 'opacity-40': !passwordHasLowerCase }"
                      >
                        <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />
                        Al menos una minúscula
                      </span>
                      <span
                        class="mt-1 flex"
                        :class="{ 'opacity-40': !passwordHasNumber }"
                      >
                        <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos
                        un número
                      </span>
                      <span
                        class="mt-1 flex"
                        :class="{ 'opacity-40': !passwordHasSpecialCharacter }"
                      >
                        <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos
                        un caracter especial (#$%&_) o puntuación (,.)
                      </span>
                    </div>
                    <div class="intro-x mt-6 px-8">
                      <span class="text-xs">Confirmar contraseña</span>
                      <div class="input-group mt-1 mb-2">
                        <input
                          :type="inputConfirmPasswordShow ? 'text' : 'password'"
                          class="form-control p-3 text-base"
                          placeholder="Confirmar contraseña"
                          style="border-right-width: 0"
                          ref="confirm-password"
                          v-model="confirmPassword"
                          @cut.prevent
                          @copy.prevent
                          @paste.prevent
                          required
                        />
                        <div
                          class="input-group-text flex cursor-pointer"
                          style="border-left-width: 0; background: white"
                          @click="
                            changeInputShowPassword({
                              ref: 'confirm-password',
                              input: 'inputConfirmPasswordShow'
                            })
                          "
                        >
                          <EyeIcon
                            class="w-4 h-4 my-auto"
                            v-if="!inputConfirmPasswordShow"
                          />
                          <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                        </div>
                      </div>
                      <span
                        class="text-xs ml-1 text-theme-6"
                        v-if="
                          password?.length >= 8 &&
                          confirmPassword?.length >= 8 &&
                          password !== confirmPassword
                        "
                        >Las contraseñas no coinciden</span
                      >
                    </div>
                    <div class="intro-x mt-5 xl:mt-8 px-8">
                      <button
                        type="submit"
                        class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
                        :disabled="!checkValidationPassword"
                      >
                        Crear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sm:col-span-1 col-span-2 md:flex hidden">
                <img
                  alt="key"
                  class="m-auto"
                  :src="require(`@/assets/images/COT-img/key.png`)"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>

<style scoped>
.full-login {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  background: #f0ecec;
}
</style>

<script>
import { getFirstErrorMessage } from '@/utils/tools'
import NavbarReset from '@/components/navbar-reset/Main.vue'
import Footer from '@/components/footer/Main.vue'

export default {
  components: {
    NavbarReset,
    Footer
  },
  data() {
    return {
      inputPasswordShow: false,
      inputConfirmPasswordShow: false,
      password: undefined,
      confirmPassword: undefined,
      token: undefined
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    const code = this.$route.params.otp
    const email = this.$route.params.email
    const error = await this.signInByOtpToken({ code, email })
    if (error) {
      this.$store.commit(
        'main/setOtpResetPassword',
        'El codigo OTP es inválido'
      )
      this.$router.push('/login')
    }
    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async signInByOtpToken({ code, email }) {
      try {
        const response = await this.axios.post('otp/validate-otp', {
          email,
          code
        })
        this.token = response.data.temporal_token
      } catch (error) {
        return getFirstErrorMessage(error)
      }
    },
    async createPassword() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          '/auth/modify-password',
          {
            new_password: this.password
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        this.$store.commit(
          'main/setOtpResetPasswordSuccess',
          'La contraseña ha sido cambiada correctamente'
        )
      } catch (error) {
        console.log(error)
        this.$store.commit(
          'main/setOtpResetPassword',
          'El codigo OTP ha caducado'
        )
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        this.$router.push('/login')
      }
    },
    changeInputShowPassword({ ref, input }) {
      this[input] = !this[input]
      this.$refs[ref].focus()
      setTimeout(() => {
        const length = this.$refs[ref].value.length
        this.$refs[ref].setSelectionRange(length, length)
      })
    }
  },
  computed: {
    passwordHasMinLenght() {
      return this.password?.length >= 8
    },
    passwordHasLowerCase() {
      return /[a-z]/.test(this.password || '')
    },
    passwordHasUpperCase() {
      return /[A-Z]/.test(this.password || '')
    },
    passwordHasNumber() {
      return /\d/.test(this.password || '')
    },
    passwordHasSpecialCharacter() {
      const specialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
      return specialChars.test(this.password || '')
    },
    checkValidationPassword() {
      return (
        this.password?.length >= 8 &&
        this.password === this.confirmPassword &&
        this.passwordHasLowerCase +
          this.passwordHasUpperCase +
          this.passwordHasNumber +
          this.passwordHasSpecialCharacter >=
          3
      )
    }
  }
}
</script>
